module.exports = __webpack_public_path__ + "static/img/2-6.ab3f213.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-6.jpg
// module id = 3t5Y
// module chunks = 1